// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__37Wb2","addWidgetButton":"Header_addWidgetButton__1D6Us","dashboardTabs":"Header_dashboardTabs__guajP","active":"Header_active__2Poxe"};